import { Text } from '@/_components';

type InfiniteScrollStatusProps = {
  loadedCount: number;
  total: number;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
};

export function InfiniteScrollStatus({ loadedCount, total }: InfiniteScrollStatusProps) {
  return (
    <div className="flex items-center justify-between px-1 py-2">
      <Text as="small" className="text-c-card-muted font-medium">
        Showing {loadedCount} of {total}
      </Text>
    </div>
  );
}
